__turbopack_context__.v({
  "checkbox": "checkbox-module-scss-module___ipa_a__checkbox",
  "label": "checkbox-module-scss-module___ipa_a__label",
  "label-disabled": "checkbox-module-scss-module___ipa_a__label-disabled",
  "wrapper": "checkbox-module-scss-module___ipa_a__wrapper",
});
